// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { RoleApi } from '../types/role.types';
import { roleHttpApi } from './role.api';
import { roleMockApi } from './role.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const roleApi: RoleApi = useMock ? roleMockApi : roleHttpApi;
